<template>
	<div v-if="this.stationListMap.length!==null && this.stationListMap.length>0">
		<GmapMap :center="center" :zoom="this.zoom" :options="mapStyle" ref="map" style="width: 100%; height: 400px">
			<!-- original code
			<GmapMarker
				:key="index"
				v-for="(location, index) in stationListMap"
				:position="{ lat: location.lat, lng: location.lng }"
				:clickable="true"
				@click="openInfoWindow(location); this.center={ lat: location.lat, lng: location.lng };"
				:icon="location.Status==='CRITICAL'?icon_ballon_red:icon_ballon_blue"
			/> */
			-->
			<GmapMarker
				:key="index"
				v-for="(location, index) in stationListMap"
				:position="{ lat: location.lat, lng: location.lng }"
				:clickable="true"
				@click="handleMarkerClick(location)"
				:icon="location.StatusATG==='ONLINE' ? icon_ballon_blue : icon_ballon_red"
			/>

			<GmapInfoWindow
				v-if="selectedLocation !== null"
				:position="{ lat: selectedLocation.lat, lng: selectedLocation.lng }"
				:opened="infoBoxOpen"
				@closeclick="infoBoxOpen = false;"
			>
				<div class="infoWindow">
					<div class="card p-0">
						<div class="card-body p-1">
							<h6 class="m-0 p-0">{{ selectedLocation.StationName }}</h6>
							<div>{{ selectedLocation.BOSStationId }}<br>{{ selectedLocation.StationAddress }}<br>STATUS: <b>{{ selectedLocation.StatusATG==="ONLINE"? "ONLINE":"OFFLINE" }}</b></div>
							<div v-if="selectedLocation.ExtraInfo">{{ selectedLocation.ExtraInfo }}</div>
							<br>
							<button class="btn btn-primary m-0 p-2" @click="closeInfoWindow(selectedLocation.StationId);">Show</button>
						</div>
					</div>
				</div>
			</GmapInfoWindow>
		</GmapMap>

	</div>
</template>

<script>

export default {
	components: {
		//Loader,
	},
	props:{
		stationListMap:[],
		centeringMap:{},
		zoom:null,
		jumlahStationFilter:null,
        mapStyle: {},
	},
	computed:{
	},
	data: () => ({
		pano:null,
		pov:null,
		center: { lat: -6.1754, lng: 106.8272 },
		selectedLocation: null,
		infoBoxOpen: false,
		icon_ballon_red: {
			url: '/logo_location_red.svg',
			size: {width: 22.5, height: 30, f: 'px', b: 'px',},
			scaledSize: {width: 22.5, height: 30, f: 'px', b: 'px',},
        },
		icon_ballon_blue: {
			url: '/logo_location_blue.svg',
			size: {width: 22.5, height: 30, f: 'px', b: 'px',},
			scaledSize: {width: 22.5, height: 30, f: 'px', b: 'px',},
        }
	}),
	mounted(){
		this.recalculateCenter(this.stationListMap)
	},
	watch:{
		stationListMap(now) {
			this.recalculateCenter(now)
		},
		centeringMap(now,before){
			if(before!==null)this.selectedLocation=before
			if(now!==null)this.selectedLocation=now
			this.infoBoxOpen = now.jumlahFilter===0?(now.selected===true?true:false):false
			this.center={lat:Number(now.lat),lng:Number(now.lng)}
		}
	},
	methods: {
        handleMarkerClick(location) {
            if (!location) return;

            this.openInfoWindow(location);

            // Use Vue.set
            this.$set(this, "center", { lat: location.lat, lng: location.lng });
        },
		recalculateCenter(now) {
			var minlat = 90
			var maxlat = -90
			var minlng = 180
			var maxlng = -180
			for(var i=0; i<now.length; i++){
				if (now[i].lat >= -20 && minlat > now[i].lat) minlat = now[i].lat
				if (now[i].lat <= 20 && maxlat < now[i].lat) maxlat = now[i].lat
				if (now[i].lng >= 80 && minlng > now[i].lng) minlng = now[i].lng
				if (now[i].lng <= 150 && maxlng < now[i].lng) maxlng = now[i].lng
			}
			this.center={lat:((maxlat-minlat)/2)+minlat,lng:((maxlng-minlng)/2)+minlng}
		},
		openInfoWindow(location) {
			this.selectedLocation = location;
			this.infoBoxOpen = true;
		},
		closeInfoWindow(value) {
			if(value!=='') {
				this.$emit('pilihStationDariGmap',value)
			}
			this.infoBoxOpen = false;
		},
	}
};
</script>

<style>
.vue-map-container {
  height: 340px;
}
</style>
